import PresentationBaseModel from './base-modeles/presentation-base-model';
import { DefaultSize } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/presentation-model-props.interface';
import { SlideSizeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-size/slide-size.interface';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWOperationType,
    TDWModuleType,
    TDWActionType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { TaskPriority } from '@src/slide/infrastructure/module/dependent/taskManager';
import _has from 'lodash/has';
import ConvertEngine from './convert/convertEngine';
import TaskGroup from '@src/slide/infrastructure/module/dependent/taskManager/taskGroup';
import { decorate, observable } from 'mobx';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { IObservableArray } from 'mobx/lib/types/observablearray';
import {
    IPresentationModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';
import { setSlideIndex } from '@src/slide/domain/ui-model/element-modeles/property/slide-number/operation';
import { ISlideRenderStateManager } from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';
import SlideModel from './slide-model';
import SectionModel from './section-model';
import { PresentationPropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/presentation/presentation-property-converter';
import GuideModelV3 from './guide-model-v3';
import { DataModelChange, IObservableDataModel, MutationSource } from '@tencent/slide-sdk-model';
import { SlideDataServices } from '../../slide-app/core/slide-data-services.core';
import { EditEvents } from '../../slide-app/core/interfaces/event.interface';

class PresentationModel extends PresentationBaseModel implements IPresentationModel {
    private static reported: boolean;
    public static async convertDataSdkToUi(sdkData, uiData: IPresentationModel, rawSdkData, options): Promise<void> {
        super.convertDataSdkToUi(sdkData, uiData, rawSdkData, options);
        global.log.info('[key process]', 'PresentationModel convert start');

        PresentationPropertyConverter.convertPartialDataFromSdkToUi(sdkData, uiData);

        // TODO 目前母版和版式不支持删除, 所以这里不需要处理
        if (!uiData.getMasterLayoutEditService?.()?.isMasterEditType) {
            if (sdkData.slideList?.length > 0) {
                if (uiData.children.length <= 0) {
                    uiData.convertDataAtPageIndex(0);
                }
                this.handleCurSlideIndex(sdkData, uiData);
            } else {
                if (uiData.selectionService) {
                    uiData.selectionService.currentSlideIndex = -1;
                }
            }
        }
        PresentationModel.prototype.convertArrayDataSdkToUi.call(uiData, sdkData, options);
        PresentationModel.prototype.converGuideDataSdkToUi.call(uiData, sdkData);

        if (_has(sdkData, 'slideHeight')) {
            if (!this.reported) {
                if (uiData.props.slideSizeType === SlideSizeType.SLIDE_SIZE_16_9) {
                    tdw({
                        opername: TDWOperationType.DOC_PPT,
                        module: TDWModuleType.PC_EDIT_PAGE,
                        action: TDWActionType.THISPAGE_SN,
                    });
                } else if (uiData.props.slideSizeType === SlideSizeType.SLIDE_SIZE_4_3) {
                    tdw({
                        opername: TDWOperationType.DOC_PPT,
                        module: TDWModuleType.PC_EDIT_PAGE,
                        action: TDWActionType.THISPAGE_FT,
                    });
                } else {
                    tdw({
                        opername: TDWOperationType.DOC_PPT,
                        module: TDWModuleType.PC_EDIT_PAGE,
                        action: TDWActionType.THISPAGE_OTH,
                    });
                }
                this.reported = true;
            }
        }
    }

    static handleCurSlideIndex(sdkData, uiData: IPresentationModel) {
        const sdkListLen = sdkData.slideList.length;
        if (!uiData.selectionService) return;
        if (uiData.selectionService.currentSlideIndex < 0) {
            if (!browser.isMobile) {
                // 移动端默认不设置选中页
                uiData.selectionService.currentSlideIndex = 0;
            }
            // 增加页或减少页，同步currentSlideIndex
        } else {
            const { currentSlide } = uiData.selectionService;
            let newIndex = -1;
            sdkData.slideList.forEach((slide, index) => {
                if (slide.id === currentSlide?.id) newIndex = index;
            });
            if (newIndex < 0 && uiData.selectionService.currentSlideIndex >= sdkListLen) {
                uiData.selectionService.currentSlideIndex = sdkListLen - 1;
            }
            if (newIndex >= 0) {
                uiData.selectionService.currentSlideIndex = newIndex;
            }
        }
    }

    static convertDataUiToSdk(uiData, sdkData) {
    }

    // 因为sdk中layoutList平铺的，而UI上layout是与master关联的，这里将layout挂载到master中
    static didConvertDataSdkToUi(sdkData, uiData, rawSdk, optionObject) {
        if (!uiData.needConvertChildren) {
            uiData.convertMasterAndLayoutPromise = Promise.resolve();
            return;
        }
        super.didConvertDataSdkToUi(sdkData, uiData, rawSdk, optionObject);
        setSlideIndex(uiData);
        // 主题
        uiData.convertThemeSdkDataToUiData();
        uiData.convertMasterAndLayoutPromise = uiData
            .convertMasterAndLayoutSdkDataToUiData();
    }
    asyncConvertSlideChildren = true; // slide的chidren 默认为异步加载
    public needConvertChildren = true;   // 是否需要转换子元素
    public convertMasterAndLayoutPromise: Promise<any>;
    private registerSdkEvent: boolean;
    private taskGroup: TaskGroup;
    private slideRenderStateManager?: ISlideRenderStateManager;

    constructor(props) {
        super(props);
        this.props = {
            style: {},
            slideWidth: DefaultSize.width,
            slideHeight: DefaultSize.height,
            slideSizeType: SlideSizeType.SLIDE_SIZE_16_9,
        };
        decorate(this.props, {
            slideSizeType: observable,
            slideWidth: observable,
            slideHeight: observable,
        });
    }
    get convertTaskGroup() {
        if (!this.taskGroup || this.taskGroup.isCanceled || this.taskGroup.isFinished) {
            this.taskGroup = new TaskGroup(
                `convert-children-${this.type}(${this.key})`,
                TaskPriority.NORMAL,
            );
            this.taskGroup.concurrent = true;
        }
        return this.taskGroup;
    }

    public converGuideDataSdkToUi(sdkData): void {
        if (!this.guideModel) {
            this.guideModel = new GuideModelV3();
            this.guideModel.bindSDK(sdkData);
        }
    }

    public convertArrayDataSdkToUi(sdkData, options): void {
        if (!this.registerSdkEvent) {
            this.registerSdkEvent = true;
            SlideDataServices.EventManager()?.on(EditEvents.LoadDocumentAllChunksSuccess, () => {
                // v3 版本首屏数据是返回完整页数的，所以分页结束后无需 setSlideIndex
                this.convertMasterAndLayoutPromise.then(() => this.changeEditableState(true));
            });
        }
        // 在编辑文档时，这个方法是同步执行的，这里不能用await代替then方法
        const promises = [
            ConvertEngine.convertArrayDataSdkToUi(
                () => SlideModel,
                sdkData.slideList, this.children, this, TaskPriority.HIGH,
            ),
        ];
        if (sdkData?.sectionList?.length > 0 && !options?.remove) {
            // 判断后台是否有 sectionList 的数据
            this.sectionList = [];
            promises.push(ConvertEngine.convertArrayDataSdkToUi(
                () => SectionModel,
                sdkData.sectionList,
                this.sectionList, this,
            ));
        } else if (this.sectionList) {
            // sdk 没有节数据，但是 uiModel 中有，说明需要删除 ui 中的节数据
            this.sectionList = undefined;
        }

        Promise.all(promises).then(() => {
            this.initSectionFoldedState?.();
        });
    }

    /**
     * replacePresentationData 用于直接替换当前 presentation，影响范围大，风险高，仅限应用模板使用
     * 一般场景要保留当前presentation，请使用 addPresentation 接口，实际操作为merge两个presentation
     */
    public replacePresentationData = (newPresentation) => {
        this.sdkData?.api.replacePresentation(newPresentation);
    };

    /**
     * 3.0数据变更之后
     * @param sdkData
     * @param change
     * @protected
     */
    protected async sdkOnDidChangeV3(
        sdkData: IObservableDataModel,
        change?: DataModelChange & { source: MutationSource },
    ): Promise<void> {
        if (!change) {
            (this.children as IObservableArray).clear();
        }
        await super.sdkOnDidChangeV3(sdkData, change);
    }

    private initSectionFoldedState(): void {
        if (!browser.isMobile) {
            if (this.sectionManager) {
                this.sectionManager.initSectionFoldedState(this.sectionList?.length ?? 0);
            }
        }
    }
}

export default PresentationModel;
